import {
  type GetStoreRequest,
  GetStoreResponse,
  GetStoresResponse,
} from "schema/gen/es/chiikipoint/wallet/v2/service_pb";
import { getTenantSlug } from "../utils";

export function getMockStores() {
  return [
    {
      id: "0191fa0d-87ac-7454-b2dd-674cbc3960e0",
      name: "みやポスーパー",
      fullAddress: "宮城県仙台市青葉区川内２６-1-1",
      city: "宮城県仙台市青葉区",
      location: {
        latitude: 38.25611519745144,
        longitude: 140.85658498337693,
      },
      category: "スーパー",
      iconUrl: "/misc/icons/company.png",
    },
    {
      id: "0191fa54-bc14-7679-8d40-d8a31fa68a77",
      name: "みやポマート",
      fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
      city: "宮城県仙台市青葉区",
      location: {
        latitude: 38.25783587179756,
        longitude: 140.87284595831724,
      },
      category: "コンビニ",
      iconUrl: "/misc/icons/company.png",
    },
    {
      id: "0191fa0d-1ef4-7303-b2db-d580b98d1169",
      name: "ドラッグみやポ",
      fullAddress: "宮城県仙台市青葉区一番町１丁目３−１",
      city: "宮城県仙台市青葉区",
      location: {
        latitude: 38.25783587179756,
        longitude: 140.87284595831724,
      },
      category: "ドラッグストア",
      iconUrl: "/misc/icons/company.png",
    },
    {
      id: "0191f9f7-3047-795d-af14-2146e59151eb",
      name: "みやポ食堂",
      fullAddress: "宮城県仙台市青葉区一番町４丁目３−２２",
      city: "宮城県仙台市青葉区",
      location: {
        latitude: 38.26350451709948,
        longitude: 140.87092366443375,
      },
      category: "飲食店",
      iconUrl: "/misc/icons/company.png",
    },
    {
      id: "0191f9ec-9019-763f-8fa1-0b8ea46c0dfe",
      name: "Hotelみやポ",
      fullAddress: "宮城県仙台市青葉区一番町４丁目１−１ オークツリー 一番町 1F",
      city: "宮城県仙台市青葉区",
      location: {
        latitude: 38.26304020197413,
        longitude: 140.8729801571959,
      },
      category: "旅館・ホテル",
      iconUrl: "/misc/icons/company.png",
    },
    {
      id: "bed51b92-95a6-4a07-99f4-a19e574c50ea",
      name: "まるもりスーパー",
      fullAddress: "〒981-2152 宮城県伊具郡丸森町鳥屋１２０番地",
      city: "宮城県伊具郡丸森町",
      location: {
        latitude: 38.25611519745144,
        longitude: 140.85658498337693,
      },
      category: "スーパー",
      iconUrl: "/misc/icons/company.png",
    },
    {
      id: "d90ef3b4-bd7c-40d0-8aa2-e221f1233ac5",
      name: "まるもりマート",
      fullAddress: "〒981-2152 宮城県伊具郡丸森町鳥屋１２０番地",
      city: "宮城県伊具郡丸森町",
      location: {
        latitude: 38.25783587179756,
        longitude: 140.87284595831724,
      },
      category: "コンビニ",
      iconUrl: "/misc/icons/company.png",
    },
    {
      id: "8b8a9f9a-f6f2-40e0-a15e-af057b4eeff1",
      name: "ドラッグまるもり",
      fullAddress: "〒981-2152 宮城県伊具郡丸森町鳥屋１２０番地",
      city: "宮城県伊具郡丸森町",
      location: {
        latitude: 38.25783587179756,
        longitude: 140.87284595831724,
      },
      category: "ドラッグストア",
      iconUrl: "/misc/icons/company.png",
    },
    {
      id: "f5ad85e1-5c05-4dde-9a79-80ac88e9ab67",
      name: "まるもり食堂",
      fullAddress: "〒981-2152 宮城県伊具郡丸森町鳥屋１２０番地",
      city: "宮城県伊具郡丸森町",
      location: {
        latitude: 38.26350451709948,
        longitude: 140.87092366443375,
      },
      category: "飲食店",
      iconUrl: "/misc/icons/company.png",
    },
    {
      id: "7bd9ef7a-6618-4c07-81f6-5537ab25e751",
      name: "Hotelまるもり",
      fullAddress: "〒981-2152 宮城県伊具郡丸森町鳥屋１２０番地",
      city: "宮城県伊具郡丸森町",
      location: {
        latitude: 38.26304020197413,
        longitude: 140.8729801571959,
      },
      category: "旅館・ホテル",
      iconUrl: "/misc/icons/company.png",
    },
  ];
}

export function handleGetStores() {
  // return new GetStoresResponse({
  //   stores: [],
  // });
  return new GetStoresResponse({
    stores: getMockStores(),
  });
}

export function handleGetStore(_: GetStoreRequest) {
  if (getTenantSlug() === "marumori") {
    return new GetStoreResponse({
      store: {
        id: "d90ef3b4-bd7c-40d0-8aa2-e221f1233ac5",
        name: "まるもりマート",
        fullAddress: "〒981-2152 宮城県伊具郡丸森町鳥屋１２０番地",
        city: "宮城県伊具郡丸森町",
        location: {
          latitude: 38.25783587179756,
          longitude: 140.87284595831724,
        },
        category: "コンビニ",
        iconUrl: "/misc/icons/company.png",
      },
      companyName: "まるもり事業者",
    });
  }
  return new GetStoreResponse({
    store: {
      id: "0191fa54-bc14-7679-8d40-d8a31fa68a77",
      name: "みやポマート",
      fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
      city: "宮城県仙台市青葉区",
      location: {
        latitude: 38.25783587179756,
        longitude: 140.87284595831724,
      },
      category: "コンビニ",
      iconUrl: "/misc/default-store-icon.png",
    },
    companyName: "まるもり事業者",
  });
}
